import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { useUsersPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'
import { ExternalLink } from './utils.components'

export type UserModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const UserModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: UserModalProps): JSX.Element => {
  const usersPermalink = useUsersPermalink()

  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.USERS]: {
          ...context[ChatContextSourceType.USERS],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to consider{' '}
        <ExternalLink to={usersPermalink}>users</ExternalLink> in your
        organization
      </p>
    ),
    [usersPermalink],
  )

  return (
    <ChatContextBooleanSelector
      title="Users"
      description={description}
      prompt="Do consider users"
      currentSelection={context[ChatContextSourceType.USERS].includeAll}
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
